import React from "react";
import classNames from "classnames";
import useDayAndTimeFromEventStartTime from "@hooks/useDayAndTimeFromEventStartTime";

export function QuickPlayEventStartTime(props: {
	startTime: string;
	isTextInline?: boolean;
}) {
	const { day, time } = useDayAndTimeFromEventStartTime(
		props.startTime,
		true
	);

	const containerClassName = classNames("card--qp__info card--bbp__info", {
		"card--qp--nowrap__info card--bbp--nowrap__info": props.isTextInline,
	});

	const timeTextClassName = classNames(
		"card--qp__info__time card--bbp__info__time",
		{
			"card--qp--nowrap__info__time card--bbp--nowrap__info__tim":
				props.isTextInline,
		}
	);

	return (
		<div className={containerClassName}>
			<span className={timeTextClassName}>
				<strong className="u-type--wgt--medium">{day}</strong> {time}
			</span>
		</div>
	);
}
